import { Stethoscope, Sparkles, Wrench, AlignJustify, MapPin } from "lucide-react";

export type CategoryKey =
  | "general"
  | "cosmetic"
  | "restorative"
  | "orthodontics"
  | "specialty";

export interface CategoryDef {
  key: CategoryKey;
  name: string;
  shortName: string;
  hubSlug: string;
  blurb: string;
  icon: typeof Stethoscope;
  serviceSlugs: string[]; // children including the hub
}

export const CATEGORIES: CategoryDef[] = [
  {
    key: "general",
    name: "General & Family Dentistry",
    shortName: "General",
    hubSlug: "general-dentistry-kalyan",
    blurb: "Routine check-ups, cleanings and family dental care for every age.",
    icon: Stethoscope,
    serviceSlugs: [
      "general-dentistry-kalyan",
      "family-dentist-kalyan",
      "dental-checkup-cleaning-kalyan",
      "tooth-extraction-kalyan",
      "dental-x-ray-opg-kalyan",
    ],
  },
  {
    key: "restorative",
    name: "Implants, Crowns & Bridges",
    shortName: "Implants",
    hubSlug: "restorative-dentistry-kalyan",
    blurb: "Dental implants, All-on-4, crowns, bridges and root canal treatment.",
    icon: Wrench,
    serviceSlugs: [
      "restorative-dentistry-kalyan",
      "dental-implants-treatment-kalyan",
      "all-on-4-implants-kalyan",
      "dental-crowns-bridges-kalyan",
      "root-canal-treatment-kalyan",
      "dental-implants-cost-kalyan",
    ],
  },
  {
    key: "cosmetic",
    name: "Cosmetic / Restorative",
    shortName: "Cosmetic",
    hubSlug: "cosmetic-dentistry-kalyan",
    blurb: "Veneers, smile design, whitening, fillings and Bioclear restorations.",
    icon: Sparkles,
    serviceSlugs: [
      "cosmetic-dentistry-kalyan",
      "dental-veneers-kalyan",
      "smile-design-kalyan",
      "teeth-whitening-cost-kalyan",
      "dental-filling-kalyan",
      "bioclear-composite-restorations-kalyan",
      "midline-diastema-treatment-kalyan",
      "bonded-restorations-kalyan",
      "inlay-onlay-overlay-kalyan",
    ],
  },
  {
    key: "orthodontics",
    name: "Orthodontics",
    shortName: "Orthodontics",
    hubSlug: "orthodontics-kalyan",
    blurb: "Braces, clear aligners and Invisalign for straight, healthy smiles.",
    icon: AlignJustify,
    serviceSlugs: [
      "orthodontics-kalyan",
      "braces-treatment-kalyan",
      "clear-aligners-kalyan",
      "invisalign-cost-kalyan",
    ],
  },
  {
    key: "specialty",
    name: "Specialty & Local",
    shortName: "Specialty",
    hubSlug: "best-dentist-in-kalyan",
    blurb: "Pediatric, gum care, emergencies and Kalyan-specific care.",
    icon: MapPin,
    serviceSlugs: [
      "pediatric-dentist-kalyan",
      "gum-disease-treatment-kalyan",
      "emergency-dentist-kalyan",
      "dentist-kalyan-west",
      "dentist-kalyan-east",
      "dentist-near-kalyan-station",
      "best-dentist-in-kalyan",
    ],
  },
];

export const ALL_SEO_SLUGS: string[] = CATEGORIES.flatMap((c) => c.serviceSlugs);

export const HUB_SLUGS = new Set(CATEGORIES.map((c) => c.hubSlug));

export const getCategoryBySlug = (slug: string): CategoryDef | undefined =>
  CATEGORIES.find((c) => c.serviceSlugs.includes(slug));